/** Kept for existing call sites. Apply no longer pads a minimum spinner time. */
export const CROP_APPLY_MIN_MS = 0;

export async function withMinVisibleDuration(promise, minMs = CROP_APPLY_MIN_MS) {
  const started = Date.now();
  const result = await promise;
  const elapsed = Date.now() - started;
  if (minMs > 0 && elapsed < minMs) {
    await new Promise((resolve) => setTimeout(resolve, minMs - elapsed));
  }
  return result;
}
